import { ColorsRaw } from '@/ui/theme/colors-raw';

export const thStyle: React.CSSProperties = {
  color: ColorsRaw.secondary.Light_Purple,
  textAlign: 'left',
};
